// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SQLEditor.css */

/* 주석 툴팁 (F2) — light/dark theme 모두 대응. */
.comment-tooltip {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.5;
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  pointer-events: auto;
  cursor: pointer;
  white-space: pre-wrap;
  word-break: break-word;
}
.comment-tooltip div:first-child {
  font-weight: 600;
  color: #1d4ed8;
  margin-bottom: 2px;
}

/* 실행계획↔에디터 연동 하이라이트 */
.cm-highlight-table {
  background: #bbdefb;
  border-radius: 2px;
  border-bottom: 2px solid #1976d2;
}
.cm-highlight-access {
  background: #c8e6c9;
  border-radius: 2px;
  border-bottom: 2px solid #388e3c;
}
.cm-highlight-filter {
  background: #fff9c4;
  border-radius: 2px;
  border-bottom: 2px solid #f9a825;
}
.cm-highlight-alias {
  background: #e1bee7;
  border-radius: 2px;
  border-bottom: 2px solid #7b1fa2;
}

/* SQL 에디터 내부 컨테이너.
   position:relative 는 미니맵(absolute)의 기준 박스다 — 빼면 미니맵이 엉뚱한 조상을
   기준으로 잡아 높이가 폭주한다.
   flex 레이아웃은 App.css 쪽에 있다(그 주석 참고). block 으로 두면 자식이 문서 전체
   높이로 늘어나 내부 스크롤이 사라지고 커서가 화면 밖으로 나간다. */
.sql-editor-inner-container {
  position: relative;
}

/* 실행된 쿼리 줄 옆에 표시되는 결과탭 점프 아이콘 (gutter marker) */
.cm-linked-result-gutter {
  background: transparent;
  border: none;
}
/* CodeMirror 기본 gutter element 의 left padding (~5px) 을 줄여 아이콘이 왼쪽으로 붙음 */
.cm-linked-result-gutter .cm-gutterElement {
  padding-left: 1px;
  padding-right: 1px;
}
/* 크기는 편집기 글자 크기(--font-size-mono, 설정 › 편집기의 기본값, 화면 확대가 그 위에 곱해진다)를 따른다 — 13px 일 때 예전과 같은 18/14px.
   고정 px 이던 때는 글자를 키워도 아이콘만 그대로였다(2026-10-07). */
.cm-linked-result-marker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--font-size-mono, 13px) * 1.385);
  height: calc(var(--font-size-mono, 13px) * 1.385);
  color: #007bff;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 150ms ease, transform 150ms ease;
}
.cm-linked-result-marker svg {
  display: block;
  width: calc(var(--font-size-mono, 13px) * 1.077);
  height: calc(var(--font-size-mono, 13px) * 1.077);
}
.cm-linked-result-marker:hover {
  color: #0056b3;
  transform: scale(1.15);
}
[data-theme="dark"] .cm-linked-result-marker {
  color: #6cb6ff;
}
[data-theme="dark"] .cm-linked-result-marker:hover {
  color: var(--color-text);
}
@media (prefers-reduced-motion: reduce) {
  .cm-linked-result-marker { transition: none; }
}

/* SQL statement 경계 — line number / 기타 gutter element 에만 점선 윗선 표시.
   Decoration.line 이 아니라 gutterLineClass 로 적용되므로 본문 .cm-line 에는 영향 없음. */
.cm-gutterElement.cm-statement-separator {
  border-top: 1px dashed var(--color-border, #d0d7de);
}
[data-theme="dark"] .cm-gutterElement.cm-statement-separator {
  border-top-color: var(--color-border, #444c56);
}

/* 읽기전용 에디터 워터마크 — 컨테이너 중앙 고정 */
.sql-editor-readonly-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 워터마크가 컨테이너 내부에만 보이도록 */
}
.sql-editor-readonly-watermark {
  position: sticky;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  overflow: visible;
  transform: translate(-50%, -50%) rotate(-25deg);
  font-size: 48px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.04);
  pointer-events: none;
  z-index: 10;
  white-space: nowrap;
  letter-spacing: 12px;
  -webkit-user-select: none;
          user-select: none;
}

/* 행번호 gutter */
.cm-lineNumbers {
  min-width: 40px !important;
}
.cm-lineNumbers .cm-gutterElement {
  cursor: pointer !important;
  min-width: 32px !important;
  text-align: right;
  padding-right: 4px !important;
}

/* 책갈피 Gutter */
.cm-bookmark-gutter {
  width: 12px !important;
  cursor: pointer;
}
.cm-bookmark-gutter .cm-gutterElement {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 8px;
  color: transparent;
  padding: 0 1px !important;
  transition: color 0.15s;
}
.cm-bookmark-gutter .cm-gutterElement:hover {
  color: #ccc;
}
.cm-bookmark-marker {
  color: #2196f3;
  font-size: 10px;
}
/* 책갈피 라인 배경 */
.cm-bookmark-line {
  background: rgba(33, 150, 243, 0.06);
  border-left: 2px solid #2196f3;
}

/* 미니맵 — **실행계획 보기와 같은 모양**(2026-10-05, MainDisplayTabs.module.css 의 .planMinimap): 맨 오른쪽 40px,
   세로 스크롤바는 감추고 미니맵이 위치 표시·끌어 옮기기를 맡는다. 본문은 오른쪽을 비워 미니맵이 글자를 가리지 않는다 */
.sql-editor-minimap {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 100%;
  background: rgba(245, 246, 248, 0.85);
  border-left: 1px solid #e0e0e0;
  cursor: pointer;
  z-index: 2;
}
.sql-editor-minimap:hover {
  background: rgba(238, 240, 244, 0.95);
}

/* **마우스를 올렸을 때 또는 커서가 편집기에 있을 때만 보인다**(2026-09-20 커서, 2026-10-05 마우스 — 실행계획 보기와 같게).
   평소에는 코드 옆에 회색 띠가 늘 붙어 있어 시선을 끌었다. 세로 스크롤바를 감췄으므로 쓰는 동안(커서)에는 보여야 한다.

   DOM 에서 빼지 않고 흐리게만 하는 이유는 SQLEditor.js 의 주석에 있다(다시 들어올 때 빈 채로
   깜빡이고, 폭이 들락거려 코드가 좌우로 출렁인다). 안 보이는 동안에는 클릭도 받지 않는다. */
.sql-editor-minimap {
  opacity: 1;
  transition: opacity 160ms ease;
}
.sql-editor-minimap.is-idle {
  opacity: 0;
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .sql-editor-minimap { transition: none; }
}
.sql-editor-minimap-host:hover .sql-editor-minimap {
  opacity: 1;
  pointer-events: auto;
}
/* 미니맵이 세로 위치를 보여 주고 끌어 옮길 수도 있으니 세로 스크롤바는 감춘다 — 가로 스크롤바는 남긴다(실행계획과 같다) */
/* 표준 속성(scrollbar-color)이 지정돼 있으면 Chrome 이 ::-webkit-scrollbar 를 통째로 무시한다 — 다크 모드는 모든 요소에
   scrollbar-color 를 걸어(App.css) 세로 스크롤바가 감춰지지 않았다. 여기서만 기본값으로 되돌린다(가로 색은 App.css 의 웹킷 규칙) */
html .sql-editor-minimap-host .cm-scroller { scrollbar-color: auto; }
.sql-editor-minimap-host .cm-scroller::-webkit-scrollbar:vertical { width: 0; }
.sql-editor-minimap-host .cm-content { padding-right: 46px; }   /* 미니맵(40px)이 긴 줄의 끝을 가리지 않게 */

.context-menu {
  position: fixed; /* 화면 전체를 기준으로 위치 */
  background-color: #383d44; /* 어두운 테마에 맞는 배경색 */
  border: 1px solid #5c616a;
  border-radius: 4px;
  list-style: none;
  margin: 0;
  padding: 5px 0;
  min-width: 180px;
  z-index: 1000; /* 다른 요소들 위에 표시되도록 높은 값 설정 */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  color: #abb2bf; /* 기본 텍스트 색상 */
}

.context-menu li {
  padding: 8px 15px;
  cursor: pointer;
  font-size: 13px;
}

.context-menu li:hover {
  background-color: #4a4f58; /* 호버 시 배경색 변경 */
  color: #dcdfe4; /* 호버 시 텍스트 색상 변경 */
}

.context-menu li.disabled {
  color: #5c616a; /* 비활성화 텍스트 색상 (어둡고 흐림) */
  cursor: not-allowed; /* 비활성화 커서 */
  opacity: 0.5; /* 투명도 낮춤 */
}

.context-menu li.disabled:hover {
  background-color: transparent; /* 호버 시 배경색 변경 없음 */
  color: #5c616a; /* 호버 시에도 비활성화 색상 유지 */
}

.context-menu-separator {
  height: 1px;
  background-color: #5c616a;
  margin: 5px 0;
  padding: 0 !important;
  cursor: default !important;
  pointer-events: none;
}

.context-menu-separator:hover {
  background-color: #5c616a !important;
}

/* CodeMirror 6는 JavaScript EditorView.theme()을 통해 스타일링됩니다 */
/* CSS에서 CodeMirror 선택 영역을 직접 스타일링하는 것은 권장되지 않습니다 */

/* 바인드 변수 표시기 스타일 */
.bind-variables-indicator {
  background-color: #e8f4fd;
  border: 1px solid #b3d9f2;
  border-radius: 6px;
  margin-bottom: 8px;
  padding: 8px 12px;
  font-size: 12px;
  color: #2c5aa0;
  animation: slideDown 0.2s ease-out;
  position: relative;
}

/* 클릭 가능한 바인드 변수 표시기 스타일 */
.bind-variables-indicator.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.bind-variables-indicator.clickable:hover {
  background-color: #d4edfa;
  border-color: #87ceeb;
  box-shadow: 0 2px 4px rgba(0, 123, 191, 0.1);
}

.edit-hint {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 11px;
  color: #87ceeb;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.bind-variables-indicator.clickable:hover .edit-hint {
  opacity: 1;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bind-variables-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  font-weight: 500;
}

.bind-variables-icon {
  margin-right: 6px;
  font-size: 14px;
}

.bind-variables-title {
  margin-right: 8px;
  color: #1a365d;
  font-weight: 600;
}

.bind-variables-count {
  color: #4a5568;
  font-weight: 400;
  font-style: italic;
}

.bind-variables-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.bind-variable-preview-item {
  background-color: #fff;
  border: 1px solid #c6d8e5;
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 11px;
  color: #2d3748;
  display: inline-flex;
  align-items: center;
}

.bind-variable-preview-item code {
  background-color: transparent;
  color: #0066cc;
  font-weight: 600;
  margin: 0 2px;
}

.bind-variables-detected {
  margin-top: 4px;
}

.bind-variables-text {
  color: #4a5568;
  font-style: italic;
  font-size: 11px;
}

.bind-variables-text code {
  background-color: #f7fafc;
  color: #2d3748;
  padding: 1px 3px;
  border-radius: 2px;
  font-weight: 600;
}

/* 바인드 변수 섹션 전체 컨테이너 */
.bind-variables-section {
  flex-shrink: 0; /* 바인드 변수 영역은 줄어들지 않음 */
  position: relative; /* z-index 적용을 위해 */
  z-index: 5; /* 에디터 위에 표시하지만 워터마크보다는 아래 */
  background-color: #f8f9fa; /* 배경색 추가로 구분 */
  border-bottom: 1px solid #e9ecef;
  margin: 0;
}

/* 토글 헤더 스타일 */
.bind-variables-toggle-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  background-color: #f1f3f5;
  border-bottom: 1px solid #dee2e6;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.bind-variables-toggle-header:hover {
  background-color: #e9ecef;
}

.bind-variables-toggle-icon {
  margin-right: 8px;
  font-size: 12px;
  color: #6c757d;
  transition: transform 0.2s ease;
}

.bind-variables-toggle-title {
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

/* 문장별 바인드 변수 컨테이너 - 가로 배치 */
.bind-statements-indicator {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 0;
  padding: 12px;
  animation: slideDown 0.3s ease-out;
}

.bind-statements-indicator .bind-variables-indicator {
  margin-bottom: 0;
  flex: 0 0 auto;
  min-width: 200px;
}

.bind-statements-indicator .bind-variables-indicator:last-child {
  margin-bottom: 0;
}
/* 다크모드 */
[data-theme="dark"] .sql-editor-inner-container { background: var(--color-bg); }
[data-theme="dark"] .context-menu { background: #2d2d2d; border-color: #555; }
[data-theme="dark"] .context-menu li { color: var(--color-text); }
[data-theme="dark"] .context-menu li:hover { background: var(--color-hover); }
[data-theme="dark"] .context-menu-separator { background: #404040; }
[data-theme="dark"] .comment-tooltip {
  background: #2d2d3a;
  color: #cdd6f4;
  border-color: #585b70;
  box-shadow: 0 4px 12px rgba(0,0,0,0.45);
}
[data-theme="dark"] .comment-tooltip div:first-child {
  color: #89b4fa;
}
[data-theme="dark"] .cm-bookmark-marker { color: #6cb6ff; }
[data-theme="dark"] .cm-bookmark-line { background: rgba(100,180,255,0.08); border-left-color: #6cb6ff; }
[data-theme="dark"] .sql-editor-minimap { background: rgba(30,30,30,0.85); border-color: #404040; }
[data-theme="dark"] .sql-editor-minimap:hover { background: rgba(37,37,38,0.95); }
[data-theme="dark"] .sql-editor-readonly-watermark { color: rgba(255,255,255,0.04); }
[data-theme="dark"] .sql-editor-connection-watermark { color: rgba(255, 255, 255, 0.10); }
[data-theme="dark"] .bind-variables-section { 
  background: var(--color-bg-secondary); 
  border-bottom-color: var(--color-border); 
}
[data-theme="dark"] .bind-variables-toggle-header { 
  background: var(--color-bg-tertiary); 
  color: var(--color-text); 
  border-bottom-color: var(--color-border); 
}
[data-theme="dark"] .bind-variables-toggle-header:hover {
  background: var(--color-hover);
}
[data-theme="dark"] .bind-variables-toggle-title {
  color: var(--color-text);
}
[data-theme="dark"] .bind-variables-toggle-icon {
  color: var(--color-text-muted);
}
[data-theme="dark"] .bind-variables-indicator { 
  background: var(--color-bg-tertiary); 
  border-color: var(--color-border); 
}
[data-theme="dark"] .bind-variables-indicator.clickable:hover {
  background: var(--color-hover);
  border-color: var(--color-hover-border, #5a5a5a);
}
[data-theme="dark"] .bind-variables-title {
  color: var(--color-text);
}
[data-theme="dark"] .bind-variables-count {
  color: var(--color-text-muted);
}
[data-theme="dark"] .edit-hint {
  color: var(--color-accent-fg);
}
[data-theme="dark"] .bind-variable-preview-item {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text-secondary);
}
[data-theme="dark"] .bind-variable-preview-item code {
  color: #6cb6ff;
}
[data-theme="dark"] .cm-highlight-table { background: rgba(30, 136, 229, 0.3); border-bottom-color: #1e88e5; }
[data-theme="dark"] .cm-highlight-access { background: rgba(67, 160, 71, 0.3); border-bottom-color: #43a047; }
[data-theme="dark"] .cm-highlight-filter { background: rgba(251, 192, 45, 0.3); border-bottom-color: #fbc02d; }
[data-theme="dark"] .cm-highlight-alias { background: rgba(142, 36, 170, 0.3); border-bottom-color: #8e24aa; }

/* CodeMirror 검색/치환 패널 다크모드 (Ctrl+F / Ctrl+H 로 표시) */
[data-theme="dark"] .cm-panel.cm-search {
  /* 체크박스 같은 네이티브 위젯이 흰색으로 그려지지 않게 */
  color-scheme: dark;
  background: #2d2d2d;
  color: #d4d4d4;
  border-top: 1px solid #404040;
  padding: 4px 6px;
}
[data-theme="dark"] .cm-panel.cm-search .cm-textfield {
  background: #1e1e1e;
  color: #d4d4d4;
  border: 1px solid #404040;
  border-radius: 3px;
  padding: 2px 6px;
}
[data-theme="dark"] .cm-panel.cm-search .cm-textfield::placeholder {
  color: #777;
}
/* 자동완성 미리보기로 입력칸이 흰색이 되는 것 방지 (autocomplete=off 를 무시하는 브라우저 대비) */
[data-theme="dark"] .cm-panel.cm-search .cm-textfield:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset !important;
  -webkit-text-fill-color: #d4d4d4;
}
[data-theme="dark"] .cm-panel.cm-search .cm-textfield:focus {
  border-color: var(--color-accent-fg);
  outline: none;
}
[data-theme="dark"] .cm-panel.cm-search .cm-button {
  background: #3c3c3c;
  color: #d4d4d4;
  border: 1px solid #505050;
  border-radius: 3px;
  padding: 2px 8px;
  background-image: none;
}
[data-theme="dark"] .cm-panel.cm-search .cm-button:hover {
  background: var(--color-hover);
  border-color: var(--color-hover-border, #5a5a5a);
  color: var(--color-text);
}
[data-theme="dark"] .cm-panel.cm-search label {
  color: #bbb;
  margin-left: 4px;
}
[data-theme="dark"] .cm-panel.cm-search label input[type="checkbox"] {
  accent-color: #0e639c;
}
[data-theme="dark"] .cm-panel.cm-search [name="close"] {
  background: transparent;
  color: #bbb;
  border: none;
  font-size: 14px;
  cursor: pointer;
}
[data-theme="dark"] .cm-panel.cm-search [name="close"]:hover {
  color: #fff;
}
/* 검색 결과 하이라이트 — 다크모드에서 가독성 확보 */
[data-theme="dark"] .cm-searchMatch {
  background: rgba(234, 179, 8, 0.35);
  outline: 1px solid rgba(234, 179, 8, 0.7);
}
[data-theme="dark"] .cm-searchMatch.cm-searchMatch-selected {
  background: rgba(234, 179, 8, 0.6);
  outline: 1px solid #eab308;
}

/* 연결명 워터마크 — 편집기 가운데에 늘 표시한다(사용자 요청 2026-09-13). 이 탭의 SQL 이 나가는 연결이다.
   **코드 뒤에** 깐다(z-index 0, DOM 에서 편집기보다 앞). 처음엔 코드 위에 5~6% 로 덮었다가
   "아무것도 안 보인다" 는 지적을 받았다 — 위에 덮은 채 진하게 하면 코드 글자에 회색 막이 씌워진다.
   클릭·선택·스크롤을 가로채지 않는다(pointer-events none). 긴 연결명은 말줄임. */
.sql-editor-connection-watermark {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 72px;
  font-size: 26px; /* 44px 은 너무 크다는 지적(2026-09-13) — 옅은 색에서도 읽히는 선까지만 줄였다 */
  font-weight: 700;
  color: rgba(0, 0, 0, 0.09);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  z-index: 0;
  animation: sql-connection-watermark-fade 180ms ease-out;
}
.sql-editor-connection-watermark > span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@keyframes sql-connection-watermark-fade {
  from { opacity: 0; transform: translateY(-3px); }
  to { opacity: 1; transform: translateY(0); }
}
@media (prefers-reduced-motion: reduce) {
  .sql-editor-connection-watermark { animation: none; }
}

/* 워터마크가 있는 편집기 — 배경은 바깥이 칠하고 CodeMirror 는 투명하게 둔다. 그래야 코드 뒤의 워터마크가 비친다.
   다크모드의 App.css [data-theme="dark"] .cm-editor { background … !important } 보다 선택자가 세야 한다. */
.sql-editor-watermark-host {
  background: var(--color-bg, #fff);
}
.sql-editor-watermark-host .cm-editor,
[data-theme="dark"] .sql-editor-watermark-host .cm-editor {
  background: transparent !important;
}

/* 바인드 변수는 편집기 **오른쪽**에(2026-10-13) — 위에 두면 세로 공간을 먹는다. 접으면 좁은 세로 띠 */
.sql-editor-body { display: flex; flex-direction: row; flex: 1 1 auto; min-height: 0; min-width: 0; }
.sql-editor-body > .bind-variables-section { flex: 0 0 auto; width: 260px; max-width: 42%; display: flex; flex-direction: column; min-height: 0; border-bottom: none; border-left: 1px solid #e9ecef; }
.sql-editor-body > .bind-variables-section.collapsed { width: 26px; }
.sql-editor-body > .bind-variables-section .bind-variables-toggle-header { flex: 0 0 auto; padding: 6px 8px; }
.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-header { flex: 1 1 auto; flex-direction: column; align-items: center; padding: 8px 4px; border-bottom: none; }
.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-icon { margin: 0 0 6px 0; }
.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-title { writing-mode: vertical-rl; white-space: nowrap; font-size: 12px; }
.sql-editor-body > .bind-variables-section .bind-statements-indicator { flex: 1 1 auto; min-height: 0; overflow: auto; flex-direction: column; flex-wrap: nowrap; gap: 8px; padding: 8px; animation: bind-side-in 160ms ease-out; }
.sql-editor-body > .bind-variables-section .bind-statements-indicator .bind-variables-indicator { min-width: 0; }
.sql-editor-body > .bind-variables-section .bind-variables-preview { display: flex; flex-direction: column; gap: 2px; overflow-wrap: anywhere; }
[data-theme="dark"] .sql-editor-body > .bind-variables-section { border-left-color: var(--color-border); }
@keyframes bind-side-in { from { opacity: 0; transform: translateX(3px); } to { opacity: 1; transform: none; } }
@media (prefers-reduced-motion: reduce) { .sql-editor-body > .bind-variables-section .bind-statements-indicator { animation: none; } }
.sql-editor-body > div:first-child { min-width: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/SQLEditor.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,yCAAyC;AACzC;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;;;yCAIyC;AACzC;EACE,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;EACvB,YAAY;AACd;AACA,yEAAyE;AACzE;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;gDACgD;AAChD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kDAAkD;AACpD;AACA;EACE,cAAc;EACd,gDAAgD;EAChD,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B,gBAAgB,EAAE;AAC/C;;AAEA;wEACwE;AACxE;EACE,mDAAmD;AACrD;AACA;EACE,8CAA8C;AAChD;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,yBAAyB;AAC7C;AACA;EACE,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA,cAAc;AACd;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;sEACsE;AACtE;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,8BAA8B;EAC9B,eAAe;EACf,UAAU;AACZ;AACA;EACE,qCAAqC;AACvC;;AAEA;;;;wDAIwD;AACxD;EACE,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,sBAAsB,gBAAgB,EAAE;AAC1C;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA,yEAAyE;AACzE;4FAC4F;AAC5F,6CAA6C,qBAAqB,EAAE;AACpE,oEAAoE,QAAQ,EAAE;AAC9E,uCAAuC,mBAAmB,EAAE,IAAI,8BAA8B;;AAE9F;EACE,eAAe,EAAE,mBAAmB;EACpC,yBAAyB,EAAE,mBAAmB;EAC9C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,aAAa,EAAE,4BAA4B;EAC3C,yCAAyC;EACzC,cAAc,EAAE,cAAc;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,cAAc,EAAE,yBAAyB;EACzC,mBAAmB,EAAE,YAAY;EACjC,YAAY,EAAE,WAAW;AAC3B;;AAEA;EACE,6BAA6B,EAAE,mBAAmB;EAClD,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4DAA4D;AAC5D,mDAAmD;;AAEnD,mBAAmB;AACnB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;EACd,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,cAAc,EAAE,uBAAuB;EACvC,kBAAkB,EAAE,mBAAmB;EACvC,UAAU,EAAE,4BAA4B;EACxC,yBAAyB,EAAE,eAAe;EAC1C,gCAAgC;EAChC,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;AACA,SAAS;AACT,kDAAkD,2BAA2B,EAAE;AAC/E,oCAAoC,mBAAmB,EAAE,kBAAkB,EAAE;AAC7E,uCAAuC,wBAAwB,EAAE;AACjE,6CAA6C,8BAA8B,EAAE;AAC7E,8CAA8C,mBAAmB,EAAE;AACnE;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,cAAc;AAChB;AACA,0CAA0C,cAAc,EAAE;AAC1D,wCAAwC,kCAAkC,EAAE,0BAA0B,EAAE;AACxG,0CAA0C,+BAA+B,EAAE,qBAAqB,EAAE;AAClG,gDAAgD,+BAA+B,EAAE;AACjF,qDAAqD,6BAA6B,EAAE;AACpF,uDAAuD,gCAAgC,EAAE;AACzF;EACE,qCAAqC;EACrC,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,wCAAwC;AAC1C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;AACA;EACE,8BAA8B;EAC9B,gDAAgD;AAClD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA,0CAA0C,mCAAmC,EAAE,4BAA4B,EAAE;AAC7G,2CAA2C,kCAAkC,EAAE,4BAA4B,EAAE;AAC7G,2CAA2C,mCAAmC,EAAE,4BAA4B,EAAE;AAC9G,0CAA0C,mCAAmC,EAAE,4BAA4B,EAAE;;AAE7G,oDAAoD;AACpD;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA,kEAAkE;AAClE;EACE,yDAAyD;EACzD,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA,gCAAgC;AAChC;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;;0DAG0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe,EAAE,wDAAwD;EACzE,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,UAAU;EACV,uDAAuD;AACzD;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA;EACE,mCAAmC,eAAe,EAAE;AACtD;;AAEA;4FAC4F;AAC5F;EACE,iCAAiC;AACnC;AACA;;EAEE,kCAAkC;AACpC;;AAEA,qEAAqE;AACrE,mBAAmB,aAAa,EAAE,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,YAAY,EAAE;AACpG,6CAA6C,cAAc,EAAE,YAAY,EAAE,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B,EAAE;AACtM,uDAAuD,WAAW,EAAE;AACpE,2EAA2E,cAAc,EAAE,gBAAgB,EAAE;AAC7G,qFAAqF,cAAc,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AACzL,mFAAmF,iBAAiB,EAAE;AACtG,oFAAoF,yBAAyB,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACrJ,wEAAwE,cAAc,EAAE,aAAa,EAAE,cAAc,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,QAAQ,EAAE,YAAY,EAAE,sCAAsC,EAAE;AAClO,kGAAkG,YAAY,EAAE;AAChH,qEAAqE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AAC/I,iEAAiE,sCAAsC,EAAE;AACzG,0BAA0B,OAAO,UAAU,EAAE,0BAA0B,EAAE,EAAE,KAAK,UAAU,EAAE,eAAe,EAAE,EAAE;AAC/G,0CAA0C,wEAAwE,eAAe,EAAE,EAAE;AACrI,qCAAqC,YAAY,EAAE","sourcesContent":["/* SQLEditor.css */\n\n/* 주석 툴팁 (F2) — light/dark theme 모두 대응. */\n.comment-tooltip {\n  background: #ffffff;\n  color: #1f2937;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  max-width: 400px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15);\n  pointer-events: auto;\n  cursor: pointer;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n.comment-tooltip div:first-child {\n  font-weight: 600;\n  color: #1d4ed8;\n  margin-bottom: 2px;\n}\n\n/* 실행계획↔에디터 연동 하이라이트 */\n.cm-highlight-table {\n  background: #bbdefb;\n  border-radius: 2px;\n  border-bottom: 2px solid #1976d2;\n}\n.cm-highlight-access {\n  background: #c8e6c9;\n  border-radius: 2px;\n  border-bottom: 2px solid #388e3c;\n}\n.cm-highlight-filter {\n  background: #fff9c4;\n  border-radius: 2px;\n  border-bottom: 2px solid #f9a825;\n}\n.cm-highlight-alias {\n  background: #e1bee7;\n  border-radius: 2px;\n  border-bottom: 2px solid #7b1fa2;\n}\n\n/* SQL 에디터 내부 컨테이너.\n   position:relative 는 미니맵(absolute)의 기준 박스다 — 빼면 미니맵이 엉뚱한 조상을\n   기준으로 잡아 높이가 폭주한다.\n   flex 레이아웃은 App.css 쪽에 있다(그 주석 참고). block 으로 두면 자식이 문서 전체\n   높이로 늘어나 내부 스크롤이 사라지고 커서가 화면 밖으로 나간다. */\n.sql-editor-inner-container {\n  position: relative;\n}\n\n/* 실행된 쿼리 줄 옆에 표시되는 결과탭 점프 아이콘 (gutter marker) */\n.cm-linked-result-gutter {\n  background: transparent;\n  border: none;\n}\n/* CodeMirror 기본 gutter element 의 left padding (~5px) 을 줄여 아이콘이 왼쪽으로 붙음 */\n.cm-linked-result-gutter .cm-gutterElement {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n/* 크기는 편집기 글자 크기(--font-size-mono, 설정 › 편집기의 기본값, 화면 확대가 그 위에 곱해진다)를 따른다 — 13px 일 때 예전과 같은 18/14px.\n   고정 px 이던 때는 글자를 키워도 아이콘만 그대로였다(2026-10-07). */\n.cm-linked-result-marker {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: calc(var(--font-size-mono, 13px) * 1.385);\n  height: calc(var(--font-size-mono, 13px) * 1.385);\n  color: #007bff;\n  cursor: pointer;\n  user-select: none;\n  transition: color 150ms ease, transform 150ms ease;\n}\n.cm-linked-result-marker svg {\n  display: block;\n  width: calc(var(--font-size-mono, 13px) * 1.077);\n  height: calc(var(--font-size-mono, 13px) * 1.077);\n}\n.cm-linked-result-marker:hover {\n  color: #0056b3;\n  transform: scale(1.15);\n}\n[data-theme=\"dark\"] .cm-linked-result-marker {\n  color: #6cb6ff;\n}\n[data-theme=\"dark\"] .cm-linked-result-marker:hover {\n  color: var(--color-text);\n}\n@media (prefers-reduced-motion: reduce) {\n  .cm-linked-result-marker { transition: none; }\n}\n\n/* SQL statement 경계 — line number / 기타 gutter element 에만 점선 윗선 표시.\n   Decoration.line 이 아니라 gutterLineClass 로 적용되므로 본문 .cm-line 에는 영향 없음. */\n.cm-gutterElement.cm-statement-separator {\n  border-top: 1px dashed var(--color-border, #d0d7de);\n}\n[data-theme=\"dark\"] .cm-gutterElement.cm-statement-separator {\n  border-top-color: var(--color-border, #444c56);\n}\n\n/* 읽기전용 에디터 워터마크 — 컨테이너 중앙 고정 */\n.sql-editor-readonly-wrapper {\n  position: relative;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden; /* 워터마크가 컨테이너 내부에만 보이도록 */\n}\n.sql-editor-readonly-watermark {\n  position: sticky;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  overflow: visible;\n  transform: translate(-50%, -50%) rotate(-25deg);\n  font-size: 48px;\n  font-weight: 900;\n  color: rgba(0, 0, 0, 0.04);\n  pointer-events: none;\n  z-index: 10;\n  white-space: nowrap;\n  letter-spacing: 12px;\n  user-select: none;\n}\n\n/* 행번호 gutter */\n.cm-lineNumbers {\n  min-width: 40px !important;\n}\n.cm-lineNumbers .cm-gutterElement {\n  cursor: pointer !important;\n  min-width: 32px !important;\n  text-align: right;\n  padding-right: 4px !important;\n}\n\n/* 책갈피 Gutter */\n.cm-bookmark-gutter {\n  width: 12px !important;\n  cursor: pointer;\n}\n.cm-bookmark-gutter .cm-gutterElement {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 8px;\n  color: transparent;\n  padding: 0 1px !important;\n  transition: color 0.15s;\n}\n.cm-bookmark-gutter .cm-gutterElement:hover {\n  color: #ccc;\n}\n.cm-bookmark-marker {\n  color: #2196f3;\n  font-size: 10px;\n}\n/* 책갈피 라인 배경 */\n.cm-bookmark-line {\n  background: rgba(33, 150, 243, 0.06);\n  border-left: 2px solid #2196f3;\n}\n\n/* 미니맵 — **실행계획 보기와 같은 모양**(2026-10-05, MainDisplayTabs.module.css 의 .planMinimap): 맨 오른쪽 40px,\n   세로 스크롤바는 감추고 미니맵이 위치 표시·끌어 옮기기를 맡는다. 본문은 오른쪽을 비워 미니맵이 글자를 가리지 않는다 */\n.sql-editor-minimap {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 40px;\n  height: 100%;\n  background: rgba(245, 246, 248, 0.85);\n  border-left: 1px solid #e0e0e0;\n  cursor: pointer;\n  z-index: 2;\n}\n.sql-editor-minimap:hover {\n  background: rgba(238, 240, 244, 0.95);\n}\n\n/* **마우스를 올렸을 때 또는 커서가 편집기에 있을 때만 보인다**(2026-09-20 커서, 2026-10-05 마우스 — 실행계획 보기와 같게).\n   평소에는 코드 옆에 회색 띠가 늘 붙어 있어 시선을 끌었다. 세로 스크롤바를 감췄으므로 쓰는 동안(커서)에는 보여야 한다.\n\n   DOM 에서 빼지 않고 흐리게만 하는 이유는 SQLEditor.js 의 주석에 있다(다시 들어올 때 빈 채로\n   깜빡이고, 폭이 들락거려 코드가 좌우로 출렁인다). 안 보이는 동안에는 클릭도 받지 않는다. */\n.sql-editor-minimap {\n  opacity: 1;\n  transition: opacity 160ms ease;\n}\n.sql-editor-minimap.is-idle {\n  opacity: 0;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sql-editor-minimap { transition: none; }\n}\n.sql-editor-minimap-host:hover .sql-editor-minimap {\n  opacity: 1;\n  pointer-events: auto;\n}\n/* 미니맵이 세로 위치를 보여 주고 끌어 옮길 수도 있으니 세로 스크롤바는 감춘다 — 가로 스크롤바는 남긴다(실행계획과 같다) */\n/* 표준 속성(scrollbar-color)이 지정돼 있으면 Chrome 이 ::-webkit-scrollbar 를 통째로 무시한다 — 다크 모드는 모든 요소에\n   scrollbar-color 를 걸어(App.css) 세로 스크롤바가 감춰지지 않았다. 여기서만 기본값으로 되돌린다(가로 색은 App.css 의 웹킷 규칙) */\nhtml .sql-editor-minimap-host .cm-scroller { scrollbar-color: auto; }\n.sql-editor-minimap-host .cm-scroller::-webkit-scrollbar:vertical { width: 0; }\n.sql-editor-minimap-host .cm-content { padding-right: 46px; }   /* 미니맵(40px)이 긴 줄의 끝을 가리지 않게 */\n\n.context-menu {\n  position: fixed; /* 화면 전체를 기준으로 위치 */\n  background-color: #383d44; /* 어두운 테마에 맞는 배경색 */\n  border: 1px solid #5c616a;\n  border-radius: 4px;\n  list-style: none;\n  margin: 0;\n  padding: 5px 0;\n  min-width: 180px;\n  z-index: 1000; /* 다른 요소들 위에 표시되도록 높은 값 설정 */\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  color: #abb2bf; /* 기본 텍스트 색상 */\n}\n\n.context-menu li {\n  padding: 8px 15px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.context-menu li:hover {\n  background-color: #4a4f58; /* 호버 시 배경색 변경 */\n  color: #dcdfe4; /* 호버 시 텍스트 색상 변경 */\n}\n\n.context-menu li.disabled {\n  color: #5c616a; /* 비활성화 텍스트 색상 (어둡고 흐림) */\n  cursor: not-allowed; /* 비활성화 커서 */\n  opacity: 0.5; /* 투명도 낮춤 */\n}\n\n.context-menu li.disabled:hover {\n  background-color: transparent; /* 호버 시 배경색 변경 없음 */\n  color: #5c616a; /* 호버 시에도 비활성화 색상 유지 */\n}\n\n.context-menu-separator {\n  height: 1px;\n  background-color: #5c616a;\n  margin: 5px 0;\n  padding: 0 !important;\n  cursor: default !important;\n  pointer-events: none;\n}\n\n.context-menu-separator:hover {\n  background-color: #5c616a !important;\n}\n\n/* CodeMirror 6는 JavaScript EditorView.theme()을 통해 스타일링됩니다 */\n/* CSS에서 CodeMirror 선택 영역을 직접 스타일링하는 것은 권장되지 않습니다 */\n\n/* 바인드 변수 표시기 스타일 */\n.bind-variables-indicator {\n  background-color: #e8f4fd;\n  border: 1px solid #b3d9f2;\n  border-radius: 6px;\n  margin-bottom: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #2c5aa0;\n  animation: slideDown 0.2s ease-out;\n  position: relative;\n}\n\n/* 클릭 가능한 바인드 변수 표시기 스타일 */\n.bind-variables-indicator.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bind-variables-indicator.clickable:hover {\n  background-color: #d4edfa;\n  border-color: #87ceeb;\n  box-shadow: 0 2px 4px rgba(0, 123, 191, 0.1);\n}\n\n.edit-hint {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 11px;\n  color: #87ceeb;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.bind-variables-indicator.clickable:hover .edit-hint {\n  opacity: 1;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bind-variables-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.bind-variables-icon {\n  margin-right: 6px;\n  font-size: 14px;\n}\n\n.bind-variables-title {\n  margin-right: 8px;\n  color: #1a365d;\n  font-weight: 600;\n}\n\n.bind-variables-count {\n  color: #4a5568;\n  font-weight: 400;\n  font-style: italic;\n}\n\n.bind-variables-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.bind-variable-preview-item {\n  background-color: #fff;\n  border: 1px solid #c6d8e5;\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 11px;\n  color: #2d3748;\n  display: inline-flex;\n  align-items: center;\n}\n\n.bind-variable-preview-item code {\n  background-color: transparent;\n  color: #0066cc;\n  font-weight: 600;\n  margin: 0 2px;\n}\n\n.bind-variables-detected {\n  margin-top: 4px;\n}\n\n.bind-variables-text {\n  color: #4a5568;\n  font-style: italic;\n  font-size: 11px;\n}\n\n.bind-variables-text code {\n  background-color: #f7fafc;\n  color: #2d3748;\n  padding: 1px 3px;\n  border-radius: 2px;\n  font-weight: 600;\n}\n\n/* 바인드 변수 섹션 전체 컨테이너 */\n.bind-variables-section {\n  flex-shrink: 0; /* 바인드 변수 영역은 줄어들지 않음 */\n  position: relative; /* z-index 적용을 위해 */\n  z-index: 5; /* 에디터 위에 표시하지만 워터마크보다는 아래 */\n  background-color: #f8f9fa; /* 배경색 추가로 구분 */\n  border-bottom: 1px solid #e9ecef;\n  margin: 0;\n}\n\n/* 토글 헤더 스타일 */\n.bind-variables-toggle-header {\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  cursor: pointer;\n  background-color: #f1f3f5;\n  border-bottom: 1px solid #dee2e6;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.bind-variables-toggle-header:hover {\n  background-color: #e9ecef;\n}\n\n.bind-variables-toggle-icon {\n  margin-right: 8px;\n  font-size: 12px;\n  color: #6c757d;\n  transition: transform 0.2s ease;\n}\n\n.bind-variables-toggle-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: #495057;\n}\n\n/* 문장별 바인드 변수 컨테이너 - 가로 배치 */\n.bind-statements-indicator {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin: 0;\n  padding: 12px;\n  animation: slideDown 0.3s ease-out;\n}\n\n.bind-statements-indicator .bind-variables-indicator {\n  margin-bottom: 0;\n  flex: 0 0 auto;\n  min-width: 200px;\n}\n\n.bind-statements-indicator .bind-variables-indicator:last-child {\n  margin-bottom: 0;\n}\n/* 다크모드 */\n[data-theme=\"dark\"] .sql-editor-inner-container { background: var(--color-bg); }\n[data-theme=\"dark\"] .context-menu { background: #2d2d2d; border-color: #555; }\n[data-theme=\"dark\"] .context-menu li { color: var(--color-text); }\n[data-theme=\"dark\"] .context-menu li:hover { background: var(--color-hover); }\n[data-theme=\"dark\"] .context-menu-separator { background: #404040; }\n[data-theme=\"dark\"] .comment-tooltip {\n  background: #2d2d3a;\n  color: #cdd6f4;\n  border-color: #585b70;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.45);\n}\n[data-theme=\"dark\"] .comment-tooltip div:first-child {\n  color: #89b4fa;\n}\n[data-theme=\"dark\"] .cm-bookmark-marker { color: #6cb6ff; }\n[data-theme=\"dark\"] .cm-bookmark-line { background: rgba(100,180,255,0.08); border-left-color: #6cb6ff; }\n[data-theme=\"dark\"] .sql-editor-minimap { background: rgba(30,30,30,0.85); border-color: #404040; }\n[data-theme=\"dark\"] .sql-editor-minimap:hover { background: rgba(37,37,38,0.95); }\n[data-theme=\"dark\"] .sql-editor-readonly-watermark { color: rgba(255,255,255,0.04); }\n[data-theme=\"dark\"] .sql-editor-connection-watermark { color: rgba(255, 255, 255, 0.10); }\n[data-theme=\"dark\"] .bind-variables-section { \n  background: var(--color-bg-secondary); \n  border-bottom-color: var(--color-border); \n}\n[data-theme=\"dark\"] .bind-variables-toggle-header { \n  background: var(--color-bg-tertiary); \n  color: var(--color-text); \n  border-bottom-color: var(--color-border); \n}\n[data-theme=\"dark\"] .bind-variables-toggle-header:hover {\n  background: var(--color-hover);\n}\n[data-theme=\"dark\"] .bind-variables-toggle-title {\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .bind-variables-toggle-icon {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .bind-variables-indicator { \n  background: var(--color-bg-tertiary); \n  border-color: var(--color-border); \n}\n[data-theme=\"dark\"] .bind-variables-indicator.clickable:hover {\n  background: var(--color-hover);\n  border-color: var(--color-hover-border, #5a5a5a);\n}\n[data-theme=\"dark\"] .bind-variables-title {\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .bind-variables-count {\n  color: var(--color-text-muted);\n}\n[data-theme=\"dark\"] .edit-hint {\n  color: var(--color-accent-fg);\n}\n[data-theme=\"dark\"] .bind-variable-preview-item {\n  background: var(--color-bg-secondary);\n  border-color: var(--color-border);\n  color: var(--color-text-secondary);\n}\n[data-theme=\"dark\"] .bind-variable-preview-item code {\n  color: #6cb6ff;\n}\n[data-theme=\"dark\"] .cm-highlight-table { background: rgba(30, 136, 229, 0.3); border-bottom-color: #1e88e5; }\n[data-theme=\"dark\"] .cm-highlight-access { background: rgba(67, 160, 71, 0.3); border-bottom-color: #43a047; }\n[data-theme=\"dark\"] .cm-highlight-filter { background: rgba(251, 192, 45, 0.3); border-bottom-color: #fbc02d; }\n[data-theme=\"dark\"] .cm-highlight-alias { background: rgba(142, 36, 170, 0.3); border-bottom-color: #8e24aa; }\n\n/* CodeMirror 검색/치환 패널 다크모드 (Ctrl+F / Ctrl+H 로 표시) */\n[data-theme=\"dark\"] .cm-panel.cm-search {\n  /* 체크박스 같은 네이티브 위젯이 흰색으로 그려지지 않게 */\n  color-scheme: dark;\n  background: #2d2d2d;\n  color: #d4d4d4;\n  border-top: 1px solid #404040;\n  padding: 4px 6px;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-textfield {\n  background: #1e1e1e;\n  color: #d4d4d4;\n  border: 1px solid #404040;\n  border-radius: 3px;\n  padding: 2px 6px;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-textfield::placeholder {\n  color: #777;\n}\n/* 자동완성 미리보기로 입력칸이 흰색이 되는 것 방지 (autocomplete=off 를 무시하는 브라우저 대비) */\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-textfield:-webkit-autofill {\n  -webkit-box-shadow: 0 0 0 1000px #1e1e1e inset !important;\n  -webkit-text-fill-color: #d4d4d4;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-textfield:focus {\n  border-color: var(--color-accent-fg);\n  outline: none;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-button {\n  background: #3c3c3c;\n  color: #d4d4d4;\n  border: 1px solid #505050;\n  border-radius: 3px;\n  padding: 2px 8px;\n  background-image: none;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search .cm-button:hover {\n  background: var(--color-hover);\n  border-color: var(--color-hover-border, #5a5a5a);\n  color: var(--color-text);\n}\n[data-theme=\"dark\"] .cm-panel.cm-search label {\n  color: #bbb;\n  margin-left: 4px;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search label input[type=\"checkbox\"] {\n  accent-color: #0e639c;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search [name=\"close\"] {\n  background: transparent;\n  color: #bbb;\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n}\n[data-theme=\"dark\"] .cm-panel.cm-search [name=\"close\"]:hover {\n  color: #fff;\n}\n/* 검색 결과 하이라이트 — 다크모드에서 가독성 확보 */\n[data-theme=\"dark\"] .cm-searchMatch {\n  background: rgba(234, 179, 8, 0.35);\n  outline: 1px solid rgba(234, 179, 8, 0.7);\n}\n[data-theme=\"dark\"] .cm-searchMatch.cm-searchMatch-selected {\n  background: rgba(234, 179, 8, 0.6);\n  outline: 1px solid #eab308;\n}\n\n/* 연결명 워터마크 — 편집기 가운데에 늘 표시한다(사용자 요청 2026-09-13). 이 탭의 SQL 이 나가는 연결이다.\n   **코드 뒤에** 깐다(z-index 0, DOM 에서 편집기보다 앞). 처음엔 코드 위에 5~6% 로 덮었다가\n   \"아무것도 안 보인다\" 는 지적을 받았다 — 위에 덮은 채 진하게 하면 코드 글자에 회색 막이 씌워진다.\n   클릭·선택·스크롤을 가로채지 않는다(pointer-events none). 긴 연결명은 말줄임. */\n.sql-editor-connection-watermark {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 72px;\n  font-size: 26px; /* 44px 은 너무 크다는 지적(2026-09-13) — 옅은 색에서도 읽히는 선까지만 줄였다 */\n  font-weight: 700;\n  color: rgba(0, 0, 0, 0.09);\n  pointer-events: none;\n  user-select: none;\n  z-index: 0;\n  animation: sql-connection-watermark-fade 180ms ease-out;\n}\n.sql-editor-connection-watermark > span {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n@keyframes sql-connection-watermark-fade {\n  from { opacity: 0; transform: translateY(-3px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n@media (prefers-reduced-motion: reduce) {\n  .sql-editor-connection-watermark { animation: none; }\n}\n\n/* 워터마크가 있는 편집기 — 배경은 바깥이 칠하고 CodeMirror 는 투명하게 둔다. 그래야 코드 뒤의 워터마크가 비친다.\n   다크모드의 App.css [data-theme=\"dark\"] .cm-editor { background … !important } 보다 선택자가 세야 한다. */\n.sql-editor-watermark-host {\n  background: var(--color-bg, #fff);\n}\n.sql-editor-watermark-host .cm-editor,\n[data-theme=\"dark\"] .sql-editor-watermark-host .cm-editor {\n  background: transparent !important;\n}\n\n/* 바인드 변수는 편집기 **오른쪽**에(2026-10-13) — 위에 두면 세로 공간을 먹는다. 접으면 좁은 세로 띠 */\n.sql-editor-body { display: flex; flex-direction: row; flex: 1 1 auto; min-height: 0; min-width: 0; }\n.sql-editor-body > .bind-variables-section { flex: 0 0 auto; width: 260px; max-width: 42%; display: flex; flex-direction: column; min-height: 0; border-bottom: none; border-left: 1px solid #e9ecef; }\n.sql-editor-body > .bind-variables-section.collapsed { width: 26px; }\n.sql-editor-body > .bind-variables-section .bind-variables-toggle-header { flex: 0 0 auto; padding: 6px 8px; }\n.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-header { flex: 1 1 auto; flex-direction: column; align-items: center; padding: 8px 4px; border-bottom: none; }\n.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-icon { margin: 0 0 6px 0; }\n.sql-editor-body > .bind-variables-section.collapsed .bind-variables-toggle-title { writing-mode: vertical-rl; white-space: nowrap; font-size: 12px; }\n.sql-editor-body > .bind-variables-section .bind-statements-indicator { flex: 1 1 auto; min-height: 0; overflow: auto; flex-direction: column; flex-wrap: nowrap; gap: 8px; padding: 8px; animation: bind-side-in 160ms ease-out; }\n.sql-editor-body > .bind-variables-section .bind-statements-indicator .bind-variables-indicator { min-width: 0; }\n.sql-editor-body > .bind-variables-section .bind-variables-preview { display: flex; flex-direction: column; gap: 2px; overflow-wrap: anywhere; }\n[data-theme=\"dark\"] .sql-editor-body > .bind-variables-section { border-left-color: var(--color-border); }\n@keyframes bind-side-in { from { opacity: 0; transform: translateX(3px); } to { opacity: 1; transform: none; } }\n@media (prefers-reduced-motion: reduce) { .sql-editor-body > .bind-variables-section .bind-statements-indicator { animation: none; } }\n.sql-editor-body > div:first-child { min-width: 0; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
